import * as XLSX from 'xlsx';

function findHeaderColumn(sheet, header) {
  const target = String(header || '').trim().toLowerCase();
  if (!target || !sheet?.['!ref']) return null;

  const range = XLSX.utils.decode_range(sheet['!ref']);
  const lastHeaderRow = Math.min(range.e.r, range.s.r + 9);

  for (let row = range.s.r; row <= lastHeaderRow; row += 1) {
    for (let column = range.s.c; column <= range.e.c; column += 1) {
      const address = XLSX.utils.encode_cell({ r: row, c: column });
      const value = sheet[address]?.v;
      if (String(value ?? '').trim().toLowerCase() === target) {
        return column;
      }
    }
  }

  return null;
}

function writeReviewedCell(sheet, properties, propertyIndex, column, value) {
  const property = properties[Number(propertyIndex)];
  const rowNumber = Number(property?.rowIndex);
  if (!Number.isInteger(rowNumber) || rowNumber < 1) {
    throw new Error('An edited recipient could not be matched to its original workbook row.');
  }

  const address = XLSX.utils.encode_cell({ r: rowNumber - 1, c: column });
  const existingCell = sheet[address] || {};
  sheet[address] = {
    ...existingCell,
    t: 's',
    v: String(value || '').trim(),
  };
  delete sheet[address].f;
  delete sheet[address].w;
}

// editedFlyers carries flyer URLs that existed only as a hyperlink behind the
// cell text. The Sheet is built from cell values and drops links, so the URL
// is written into the mapped flyer column. A flyer never blocks the campaign:
// without a mapped flyer column these are left as they are.
export function applyEmailEditsToWorkbook({
  base64Excel,
  emailHeader,
  properties = [],
  editedEmails = {},
  flyerHeader = null,
  editedFlyers = {},
}) {
  const edits = Object.entries(editedEmails);
  const flyerEdits = flyerHeader ? Object.entries(editedFlyers || {}) : [];
  if (edits.length === 0 && flyerEdits.length === 0) return base64Excel;

  const workbook = XLSX.read(base64Excel, { type: 'base64' });
  const sheetName = workbook.Sheets['FOR LEASE'] ? 'FOR LEASE' : workbook.SheetNames[0];
  const sheet = workbook.Sheets[sheetName];

  if (edits.length > 0) {
    const emailColumn = findHeaderColumn(sheet, emailHeader);

    if (emailColumn === null) {
      throw new Error(`The mapped email column "${emailHeader || 'Email'}" was not found in the uploaded workbook.`);
    }

    edits.forEach(([propertyIndex, reviewedEmail]) => {
      writeReviewedCell(sheet, properties, propertyIndex, emailColumn, reviewedEmail);
    });
  }

  const flyerColumn = flyerEdits.length > 0 ? findHeaderColumn(sheet, flyerHeader) : null;
  if (flyerColumn !== null) {
    flyerEdits.forEach(([propertyIndex, url]) => {
      writeReviewedCell(sheet, properties, propertyIndex, flyerColumn, url);
    });
  }

  return XLSX.write(workbook, { type: 'base64', bookType: 'xlsx' });
}
